import AdminMain from "@/views/Admin.main.vue";
import Page404 from "@/views/Page404.vue";
import Contact from "@/views/contact.vue";
import Lemon from "@/views/Lemon/Lemon.vue";
import AdminAnimation from "@/views/AdminAnimation/AdminAnimation.vue";
import AdminDocument from "@/views/AdminDocument/AdminDocument.vue";
import Bill from "@/views/Invoices/Invoices.vue";
import Commands from "@/views/Commands/Commands.vue";
import Offers from "@/views/Offre/Offer.vue";
import Communication from "@/views/Communication/Communication.vue";
import Home from "@/views/Home/Home.vue";
import Information from "@/views/Information/Information.vue";
import Login from "@/views/Login.vue";
import UserMain from "@/views/User.main.vue";
import { RouteConfig } from "vue-router";
import ForgotPassword from "@/views/Auth/ForgotPassword.vue";
import ResetPassword from "@/views/Auth/ResetPassword.vue";
import Success from "@/views/GoCardless/Success.vue";
import Error from "@/views/GoCardless/Error.vue";

export type RouteConfigDisplay = Array<
  RouteConfig & {
    displayName?: string;
    sep?: boolean;
  }
>;

const userRoutes: RouteConfigDisplay = [
  {
    displayName: "Accueil",
    name: "home",
    path: "",
    component: Home,
  },
  {
    displayName: "Vos infos",
    path: "infos",
    component: Information,
  },
  {
    displayName: "Vos commandes",
    path: "commands",
    component: Commands,
  },
  {
    displayName: "Vos factures",
    path: "invoices",
    component: Bill,
  },
  {
    displayName: "Vos communications",
    path: "communication",
    sep: true,
    component: Communication,
  },
  {
    displayName: "Nos offres",
    path: "offers",
    sep: true,
    component: Offers,
  },
  {
    displayName: "Contact",
    sep: true,
    component: Contact,
    path: "contact",
  },
  {
    path: "404",
    component: Page404,
  },
];

const adminRoute: RouteConfigDisplay = [
  {
    path: "adminText",
    displayName: "Animation",
    component: AdminAnimation,
  },
  {
    path: "adminDocument",
    displayName: "Documents",
    component: AdminDocument,
  },
];

const parseRoute = (route: RouteConfigDisplay) => {
  return route.map(({ path, name, ...rest }) => ({
    ...rest,
    path,
    name: name ? name : path,
    props: true,
    meta: { requiresAuth: true },
  }));
};

export const userParsedRoutes = parseRoute(userRoutes);
export const adminParsedRoutes = parseRoute(adminRoute);

export const AppRoutes: RouteConfigDisplay = [
  {
    path: "/",
    component: UserMain,
    children: userParsedRoutes,
  },
  {
    path: "/",
    component: AdminMain,

    // add tmp redirection
    children: [
      ...adminParsedRoutes,
      {
        path: "",
        redirect: "/adminText",
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: ForgotPassword
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPassword
  },
  {
    path: "/lemon",
    name: "lemon",
    component: Lemon,
  },
  {
    name: "gocardlessSuccess",
    component: Success,
    path: "/gocardless/success",
  },
  {
    name: "gocardlessCancel",
    component: Error,
    path: "/gocardless/error",
  },
  {
    path: "*",
    redirect: "/404",
  },
];
